(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/selfservice-cart/assets/javascripts/actions/add-items.js') >= 0) return;  svs.modules.push('/components/components/selfservice-cart/assets/javascripts/actions/add-items.js');
"use strict";


const addItems = callback => (items, callbackFn, timeout) => {
  callback(items, callbackFn, timeout);
};
setGlobal('svs.components.selfserviceCart.fns.actions.addItems', addItems);

 })(window);